import {
  Grid,
  Button,
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import {
  ConfirmDangerModalComponent,
  ErrorModal,
  UploadWidget,
} from "@soqs/common";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { PAGES } from "../App";
import { uploadfiles } from "../features/API";
import {
  cancel,
  dropdownopts,
  requiredFiles,
  setConfirmMessage,
  setPage,
} from "../features/AppSlice";

import { config } from "../config";
//import UploadWidget from "./UploadDocs/UploadWidget";

const UploadDocs = () => {
  const dispatch = useDispatch();
  const dropdownoptions = useSelector(dropdownopts);
  const files_to_be_uploaded = useSelector(requiredFiles);
  const [files, setFiles] = useState({});
  const [uploading, setUploading] = useState(false);
  const [confirmClearModal, setConfirmClearModal] = useState(false);
  const [errors, setErrors] = useState(null);
  const [bypassValidation, setBypassValidation] = useState(false);
  const [disabledUpload, setDisabledUpload] = useState(true);
  const [validating, setValidating] = useState(0);

  const upload = (fg) => {
    let files_to_upload = [];
    for (let filegroup in fg) {
      for (let file of fg[filegroup]) {
        let nf = new File([file], filegroup + "_" + file.name, {
          type: file.type,
        });
        files_to_upload.push(nf);
      }
    }
    setUploading(true);
    uploadfiles(files_to_upload)
      .then((data) => {
        setUploading(false);
        if (data.error) {
          setErrors(data);
        } else {
          dispatch(setConfirmMessage(data));
          dispatch(setPage(PAGES.Confirmation));
        }
      })
      .catch((err) => {
        setUploading(false);
        setErrors(err);
      });
  };
  let sections = files_to_be_uploaded.map((file) => {
    return dropdownoptions.filter(
      (ddo) => ddo.set === "document" && parseInt(ddo.value) === file.IntVal
    )[0];
  });

  const setFilesAndCheck = (files_l) => {
    let disabled = false;
    if (Object.keys(files_l).length !== sections.length) {
      disabled = true;
    } else {
      for (let filegroup in files_l) {
        if (files_l[filegroup].length === 0) {
          disabled = true;
          break;
        }
      }
    }
    setFiles(files_l);
    setDisabledUpload(disabled);
  };

  return (
    <>
      {window.REACT_APP_CONFIG.ENVIRONMENT === "development" ||
      window.REACT_APP_CONFIG.ENVIRONMENT === "qadebug" ? (
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={bypassValidation}
                onChange={({ target }) => {
                  console.log(target.checked);
                  setBypassValidation(target.checked);
                }}
                name="bypassValidation"
              />
            }
            label="Bypass FE validation"
          />
        </FormGroup>
      ) : null}
      <Grid container spacing={2} direction="column">
        {sections?.map((i, idx) => (
          <>
            <UploadWidget
              key={idx}
              sectionName={i?.description}
              sectionIndex={idx}
              sectionInfo={`${i?.info} ${files_to_be_uploaded[idx]?.StringVal}`}
              cbSetFiles={(f) => {
                let newf = files;
                newf[`${idx}`] = f;
                setFilesAndCheck(newf);
              }}
              setErrors={setErrors}
              otherFiles={Object.entries(files)
                .filter(([id]) => id !== String(idx))
                .flatMap(([, f]) => f)}
              cbValidating={(busy) => setValidating((v) => v + (busy ? 1 : -1))}
              validation={
                config.ENVIRONMENT === "development" ||
                config.ENVIRONMENT === "qadebug"
                  ? !bypassValidation
                  : undefined
              }
            />
          </>
        ))}
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Card>
          <CardContent>
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="space-between"
            >
              <Grid>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setConfirmClearModal(true);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid>
                <Button
                  variant="contained"
                  color="primary"
                  loading={uploading}
                  onClick={() => {
                    upload(files);
                  }}
                  disabled={
                    (window.REACT_APP_CONFIG.ENVIRONMENT === "development" ||
                      window.REACT_APP_CONFIG.ENVIRONMENT === "qadebug") &&
                    bypassValidation
                      ? false
                      : disabledUpload
                  }
                >
                  Upload Documents
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <ConfirmDangerModalComponent
          open={confirmClearModal}
          onClose={() => {
            setConfirmClearModal(false);
          }}
          cbConfirm={() => {
            setConfirmClearModal(false);
            dispatch(cancel());
          }}
          title="Cancel Uploading"
          subheader="Are you sure you want to cancel the upload and return to the previous page?"
          confirmText="Cancel Uploading"
          cancelText="Continue Uploading"
        />
        {/* Localerror modal required to prevent rerender as the uploading is not controlled by redux as per redux best practises */}
        <ErrorModal
          title={
            errors?.errortitle
              ? errors?.errortitle
              : typeof errors?.error === "string" &&
                  errors?.error?.indexOf("|") > -1
                ? errors?.error?.split("|")[0]
                : "Error"
          }
          open={errors !== null}
          onClose={() => {
            if (errors?.fatal) {
              dispatch(cancel());
            } else {
              setErrors(null);
            }
          }}
          subheader={
            Array.isArray(errors?.error) ? (
              <ul>
                {errors?.error.map((e, idx) => (
                  <li key={idx}>{e.replace("- ", "")}</li>
                ))}
              </ul>
            ) : (
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    errors?.error?.indexOf("|") > -1
                      ? errors?.error?.split("|")[1]
                      : errors?.error,
                }}
              ></p>
            )
          }
        />
      </Grid>
    </>
  );
};

export default UploadDocs;
